<template>
  <div class="email-expanded-file-reader">
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="800px" persistent content-class="expanded-file-reader-dialog">
      <template>
        <div class="custom-empty-modal-wrapper expanded-file-reader-modal">
          <!-- Modal Header -->
          <div class="modal-header m-header">
            <div class="title-header">
              <span>{{ $t('components.file_management.preview_attachments') }}</span>
            </div>
          </div>

          <!-- Modal Content -->
          <div class="modal-content file-upload-dialog-wrapper">
            <!-- Drag and Drop Area (when no files) -->
            <div
              v-if="fileList.length === 0"
              class="drop-zone email-file-drop-zone"
              :class="{ 'drag-over': isDragging }"
              @dragover.prevent="isDragging = true"
              @dragleave.prevent="isDragging = false"
              @drop.prevent="handleDrop"
            >
              <div class="hover-overlay">
                <span>{{ $t('components.file_management.drop_files') }}</span>
              </div>
              <input
                type="file"
                multiple
                ref="fileInput"
                id="file-input"
                style="display: none"
                @change="handleFileSelect"
                accept=".pdf, .zip"
              />
              <svg
                class="drop-zone-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 348.31 305.74"
              >
                <g>
                  <path
                    class="cls-1"
                    d="M324.79,150.75c7.11,81.49-62.05,183.4-162.58,147.62-84.24-29.99-210.73-105.88-142.97-154.6C163.88,39.77,72.9,13.19,162.65,15.97c100.81,3.12,152.56,24.91,162.15,134.79Z"
                  />
                  <path
                    class="cls-2"
                    d="M322.97,235.22h-73.51c-.85-.33-1.45-1.15-1.45-2.11,0-1.25,1.01-2.27,2.27-2.27h38.8V89.52c0-12.06-9.78-21.83-21.83-21.83H81.22c-12.06,0-21.83,9.78-21.83,21.83v141.32h30.9c1.25,0,2.26,1.01,2.26,2.27,0,.96-.6,1.78-1.45,2.11H25.49c-3.45,0-6.25,2.8-6.25,6.25s2.8,6.25,6.25,6.25h297.48c3.45,0,6.25-2.8,6.25-6.25s-2.8-6.25-6.25-6.25Z"
                  />
                  <path
                    class="cls-3"
                    d="M224.33,200.46h-100.2c-5.23,0-9.48-3.71-9.48-8.27v-29.68c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v29.68c0,1.77,2.05,3.27,4.48,3.27h100.2c2.43,0,4.48-1.5,4.48-3.27v-29.68c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v29.68c0,4.56-4.25,8.27-9.48,8.27Z"
                  />
                  <path
                    class="cls-3"
                    d="M185.8,184.2h-23.13c-1.38,0-2.5-1.12-2.5-2.5v-38.4l-18.23.05h0c-1.02,0-1.95-.63-2.32-1.58-.38-.95-.13-2.05.62-2.75l32.31-30.26c.96-.9,2.45-.9,3.41,0l32.31,30.09c.75.7,1,1.79.62,2.74-.37.95-1.3,1.58-2.32,1.59l-18.25.05v38.46c0,1.38-1.12,2.5-2.5,2.5ZM165.16,179.19h18.13v-38.45c0-1.38,1.12-2.5,2.49-2.5l14.41-.04-25.97-24.19-25.97,24.32,14.39-.04h0c.66,0,1.3.26,1.77.73.47.47.74,1.11.74,1.77v38.4Z"
                  />
                </g>
              </svg>
              <p class="drop-zone-text">
                {{ $t("components.file_management.upload_instructions") }}
              </p>
              <button
                class="drop-zone-button"
                @click="triggerFileInput"
              >
                {{ $t("page_2.page_2_3.upload_pop.btn_1") }}
              </button>
            </div>

            <!-- File List (when files exist) -->
            <div v-else class="tag-file-main-wrapp full email-file-list">
              <!-- File List Header -->
              <div class="file-list-header">
                <div class="file-count-title">
                  {{
                    files_selected.length === 0
                      ? $t("components.file_management.mark_documents")
                      : $t("components.file_management.marked_documents", { count: files_selected.length })
                  }}
                </div>
                <div class="select-all-action" @click="selectAllFiles()">
                  <span>{{
                    files_selected.length === fileList.length
                      ? $t("components.file_management.unmark_all")
                      : $t("components.file_management.mark_all")
                  }}</span>
                  <div class="checkbox-icon">
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 226 229"
                      xmlns="http://www.w3.org/2000/svg"
                      style="fill-rule: evenodd; clip-rule: evenodd; stroke-linecap: round; stroke-miterlimit: 10;"
                    >
                      <g transform="matrix(0.75,0,0,0.75,-10969.9,-21206.7)">
                        <g transform="matrix(5.55556,0,0,5.55556,0,0)">
                          <g transform="matrix(0.669761,0.742576,0.742576,-0.669761,2657.52,5115.65)">
                            <path d="M-1.213,-2.728L6.134,-2.728" style="fill: none; stroke: rgb(194, 194, 206); stroke-width: 3px;" />
                          </g>
                        </g>
                        <g transform="matrix(5.55556,0,0,5.55556,0,0)">
                          <g transform="matrix(-0.573018,0.819542,0.819542,0.573018,2669.3,5123.29)">
                            <path d="M-16.651,-8.675L4.52,-8.675" style="fill: none; stroke: rgb(194, 194, 206); stroke-width: 3px;" />
                          </g>
                        </g>
                        <g transform="matrix(5.55556,0,0,5.55556,0,0)">
                          <g transform="matrix(1,0,0,1,2671.36,5114.18)">
                            <path d="M0,6.643L0,10.931C0,13.217 -1.854,15.071 -4.14,15.071L-19.359,15.071C-21.646,15.071 -23.499,13.217 -23.499,10.931L-23.499,-4.288C-23.499,-6.575 -21.646,-8.428 -19.359,-8.428L-11.75,-8.428" style="fill: none; stroke: rgb(194, 194, 206); stroke-width: 3px;" />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- File List Container -->
              <div class="file-list-container file-wrapp-selection" :key="file_list_refresher">
                <div
                  v-for="(file, index) in fileList"
                  :key="file.name + index"
                  :class="[
                    'email-file-item single-file-wrapp',
                    files_selected.map((p) => p.id).includes(file.id) ? 'selected' : 'unselected'
                  ]"
                  @click="fileClickedEvent(file)"
                >
                  <div class="file-info left-side-wrapp">
                    <div class="file-icon">
                      <img :src="getFileIcon(file.name)" :alt="file.name" />
                    </div>
                    <span class="file-name">{{ file.name }}</span>
                  </div>
                  <div class="file-actions file-action">
                    <span v-if="checkAttachmentConvertability(file.name)" class="conversion-badge">
                      {{ $t("components.file_management.available_conversion") }}
                    </span>
                    <div class="download-btn" @click.stop="downloadFile(file)">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.01 16.79">
                        <g>
                          <path
                            d="M17.17,8.97c-.25-.01-.45.07-.6.22-.17.17-.26.42-.26.75v2.62c0,1.48-1.03,2.52-2.49,2.52-3.21,0-6.41,0-9.62,0-1.47,0-2.49-1.04-2.49-2.51v-1.04c0-.55,0-1.1,0-1.65,0-.28-.09-.52-.25-.68-.15-.15-.36-.23-.6-.23h0c-.5,0-.84.37-.84.92,0,.32,0,.65,0,.97,0,.54,0,1.08,0,1.61-.03,1.19.4,2.29,1.22,3.11.78.77,1.84,1.21,2.93,1.21.05,0,.09,0,.14,0,1.08-.04,2.18-.03,3.25-.02.49,0,.98,0,1.47,0h.23s1.32,0,1.32,0c1.18,0,2.35,0,3.53,0,1.93-.03,3.65-1.56,3.85-3.42.09-.81.08-1.64.08-2.44,0-.32,0-.65,0-.97,0-.59-.3-.96-.83-.97Z"
                            class="cls-1"
                          />
                          <path
                            d="M8.35,12.43c.17.17.4.32.66.32.21,0,.44-.09.68-.34l3.29-3.29c.32-.32.65-.65.96-.98.27-.29.31-.66.11-1.01-.19-.33-.54-.48-.9-.38-.17.04-.33.15-.51.33-.84.83-1.67,1.67-2.54,2.54l-.24.24V1.14s0-.07,0-.07c0-.12,0-.23-.01-.35-.05-.43-.37-.71-.81-.72-.25,0-.46.07-.6.21-.17.17-.25.42-.25.76v8.89s-1.01-1.01-1.01-1.01c-.6-.6-1.21-1.21-1.81-1.81-.19-.18-.4-.29-.62-.31-.23-.02-.45.07-.62.24-.35.35-.32.87.05,1.25,1.4,1.4,2.8,2.81,4.2,4.21Z"
                            class="cls-1"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Actions -->
          <div class="modal-actions email-response-activities bottom-act">
            <div class="left-actions attachment-button m-btn-wrapp">
              <button class="email-reader-btn btn-cancel m-cancel-btn m-single-btn" @click="dialog = false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
                  <g>
                    <path
                      class="cls-2"
                      d="M30.81,31.46c-.32,0-.64-.12-.88-.37L10.68,11.85c-.49-.49-.49-1.28,0-1.77.49-.49,1.28-.49,1.77,0l19.25,19.25c.49.49.49,1.28,0,1.77-.24.24-.56.37-.88.37Z"
                    />
                    <path
                      class="cls-2"
                      d="M11.56,31.46c-.32,0-.64-.12-.88-.37-.49-.49-.49-1.28,0-1.77L29.92,10.08c.49-.49,1.28-.49,1.77,0,.49.49.49,1.28,0,1.77L12.44,31.1c-.24.24-.56.37-.88.37Z"
                    />
                    <rect class="cls-1" x="0" width="42" height="42" />
                  </g>
                </svg>
                {{ $t("repetitive.cancel") }}
              </button>
            </div>
            <div class="right-actions right-button-wrapp m-btn-wrapp">
              <button
                v-if="files_selected.length > 0"
                class="email-reader-btn btn-primary m-save-btn m-single-btn"
                @click="openFolderSelect(0)"
              >
                {{ $t("components.email.file_management.store_original") }}
              </button>
              <button
                v-if="areSelectedFilesConvertable() && files_selected.length > 0"
                class="email-reader-btn btn-secondary m-save-btn m-single-btn"
                @click="openFolderSelect(1)"
              >
                {{ $t("components.email.file_management.convert_to_pdf") }}
              </button>
            </div>
          </div>
        </div>
      </template>

      <folder-select-modal
        id="expanded-file-reader"
        ref="folderSelect"
        @folderSelected="handleAttachmentMove"
      />
    </v-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import {
  canConvertFileToPDF,
  returnFileTypeImage,
} from "../../../helpers/file";
import FolderSelectModal from "../../fileManagement/FolderSelectModal.vue";
import ms_email from "../../../apiCallers/promise_handler_db/ms_email";
import CustomSpinner from "../../generalComponents/CustomSpinner.vue";
import { switchGlobalLoaderState } from '../../../helpers/loader/global';
export default {
  components: { FolderSelectModal, CustomSpinner },
  data() {
    return {
      dialog: false,
      fileList: [],

      files_selected: [],

      snackbar: false,
      snackbarMessage: "",
      isUploading: false,

      file_list_refresher: 1,

      selected_file_for_tag: null,

      success_flag: false,

      error_flag: false,
      error_files_string: "",

      type_of_store_files: 0,

      isDragging: false,
    };
  },

  methods: {
    downloadFile(attachment) {
      // Decode Base64 content
      const byteCharacters = atob(attachment.contentBytes);

      // Convert to byte array
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Create Blob
      const blob = new Blob([byteNumbers], { type: attachment.contentType });

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = attachment.name || "downloaded_file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    areSelectedFilesConvertable() {
      return (
        this.files_selected.length ==
        this.files_selected.filter((p) =>
          this.checkAttachmentConvertability(p.name)
        ).length
      );
    },
    checkAttachmentConvertability(file_name) {
      return canConvertFileToPDF(file_name);
    },

    async handleAttachmentMove(selected_vals) {
      switchGlobalLoaderState("Pohranjivanje komunikacije.")
      const need_to_pdf = this.type_of_store_files == 1;

      try {
        for (const file of this.files_selected) {
          await ms_email.saveEmailAttachment(
            "",
            "attachment-upload",
            selected_vals.case_id,
            selected_vals.selected_folder.id,
            file,
            need_to_pdf
          );
        }
        this.$toast.success(this.$t('components.email.main.save_success'));
      } catch (err) {
        console.error("Error saving attachment via backend:", err);
        this.$toast.error(this.$t('components.email.main.save_error'));
      } finally {
        switchGlobalLoaderState();
      }
    },
    openFolderSelect(filter = 0) {
      this.type_of_store_files = filter;
      this.$refs.folderSelect.open(filter);
    },
    selectAllFiles() {
      if (this.fileList.length == this.files_selected.length) {
        this.files_selected = [];
      } else {
        this.files_selected = [...this.fileList];
      }
    },

    openDialog(file_list = []) {
      this.fileList = file_list;
      this.dialog = true;
      setTimeout(function () {
        var upl = document.getElementById("tag-upload-title");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(upl.nextSibling).addClass("spis-megawrapper-parent");
        $(".spis-megawrapper").removeClass("active");
        $(".main-file-upload-wrapper").find(".spis-megawrapper:first").click();
      }, 100);
    },
    getFileIcon(filename) {
      return returnFileTypeImage(filename);
    },
    closeDialog() {
      this.dialog = false;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
    },
    handleDrop(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    addFiles(files) {
      files.forEach((file) => {
        if (!this.fileList.some((f) => f.name === file.name)) {
          this.fileList.push(file);
        }
      });
    },
    removeFile(index) {
      this.fileList.splice(index, 1);
    },

    fileClickedEvent(single_file) {
      const file_position = this.files_selected.findIndex(
        (p) => p.id == single_file.id
      );
      if (file_position == -1) {
        this.files_selected.push(single_file);
      } else {
        this.files_selected.splice(file_position, 1);
      }
    },
    //   async uploadFiles() {
    //     this.isUploading = true;
    //     console.log(
    //       "uploading files",
    //       this.fileList,
    //       this.selected_upload_folder,
    //       this.group_id
    //     );
    //     await uploadFiles(
    //       this.group_id,
    //       this.selected_upload_folder,
    //       this.fileList,
    //       this.default_tag,
    //       this.active_tag
    //     ).then(async (resp) => {
    //       console.log("Awaited response from upload", resp);
    //       if (resp.unsuccessfulUploads.length > 0) {
    //         this.error_flag = true;
    //         this.error_files_string = resp.unsuccessfulUploads
    //           .map((p) => p.name)
    //           .join(",");
    //         this.isUploading = false;
    //       } else {
    //         this.success_flag = true;
    //         this.isUploading = false;
    //         this.fileList = [];
    //         this.$emit("refresh");
    //         this.active_tag = this.default_tag;
    //         const filtered_su = resp.successfulUploads.filter(p=> p.tag.id != this.default_tag.id)
    //         await fileTaggingHandler
    //           .upsert(this.group_id, filtered_su, this.default_tag)
    //           .then((response) => {
    //             console.log(response);
    //           });
    //       }
    //       setTimeout(() => {
    //         this.success_flag = false;
    //         this.error_flag = false;
    //       }, 3000);
    //       setTimeout(() => {
    //         this.dialog = false;
    //       }, 1000);
    //     });
    //   },
  },
  async created() {},
  mounted() {},
};
</script>